import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Post, Comment } from '../../types';

const PostDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [comment, setComment] = useState('');

  // 模拟文章数据
  const mockPost: Post = {
    id: '1',
    title: 'React Hooks 最佳实践',
    content: `本文将分享一些使用 React Hooks 的最佳实践和常见陷阱。

## 1. 使用 useState 的最佳实践

- 将相关的状态组合在一起
- 使用函数式更新
- 避免在条件语句中使用 hooks

## 2. useEffect 的使用技巧

- 明确依赖项
- 使用 cleanup 函数
- 避免不必要的重渲染

## 3. 自定义 Hooks

- 提取可复用的逻辑
- 保持 hooks 的单一职责
- 使用 TypeScript 类型定义`,
    author: {
      id: '1',
      uuid: 'user-1',
      name: '李华',
      email: 'lihua@example.com',
      avatar: 'https://i.pravatar.cc/40?img=10',
      bio: '前端开发工程师 | React专家',
      createdAt: '2023-01-01',
      updatedAt: '2023-01-01'
    },
    category: 'article',
    tags: ['React', 'Hooks', '前端'],
    createdAt: '2023-01-01',
    updatedAt: '2023-01-01'
  };

  // 模拟评论数据
  const mockComments: Comment[] = [
    {
      id: '1',
      content: '非常实用的分享，感谢！',
      author: {
        id: '2',
        uuid: 'user-2',
        name: '王明',
        email: 'wangming@example.com',
        avatar: 'https://i.pravatar.cc/40?img=11',
        bio: '全栈工程师',
        createdAt: '2023-01-01',
        updatedAt: '2023-01-01'
      },
      postId: mockPost.id,
      createdAt: '2023-01-01',
      updatedAt: '2023-01-01'
    }
  ];

  const handleCommentSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (comment.trim()) {
      // TODO: 处理评论提交
      setComment('');
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* 文章内容 */}
      <article className="bg-white shadow rounded-lg overflow-hidden">
        <div className="px-4 py-5 sm:px-6">
          <div className="flex items-center justify-between">
            <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-primary-100 text-primary-800">
              {mockPost.category === 'article' ? '文章' : mockPost.category === 'job' ? '职位' : '专栏'}
            </span>
            <span className="text-sm text-gray-500">
              {new Date(mockPost.createdAt).toLocaleDateString()}
            </span>
          </div>
          <h1 className="mt-2 text-3xl font-bold text-gray-900">{mockPost.title}</h1>
          <div className="mt-4 flex items-center">
            <div className="flex-shrink-0">
              <img
                className="h-10 w-10 rounded-full"
                src={mockPost.author.avatar}
                alt={mockPost.author.name}
              />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-900">
                <Link to={`/profile/${mockPost.author.id}`}>{mockPost.author.name}</Link>
              </p>
              <p className="text-sm text-gray-500">{mockPost.author.bio}</p>
            </div>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            {mockPost.tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
        <div className="px-4 py-5 sm:p-6 prose max-w-none">
          {mockPost.content}
        </div>
      </article>

      {/* 评论区 */}
      <div className="mt-8 bg-white shadow rounded-lg overflow-hidden">
        <div className="px-4 py-5 sm:px-6">
          <h2 className="text-lg font-medium text-gray-900">评论</h2>
          <form onSubmit={handleCommentSubmit} className="mt-4">
            <div>
              <textarea
                rows={3}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
                placeholder="写下你的评论..."
              />
            </div>
            <div className="mt-3">
              <button
                type="submit"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                发表评论
              </button>
            </div>
          </form>
        </div>
        <div className="border-t border-gray-200">
          {mockComments.map((comment) => (
            <div key={comment.id} className="px-4 py-5 sm:px-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <img
                    className="h-10 w-10 rounded-full"
                    src={comment.author.avatar}
                    alt={comment.author.name}
                  />
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-900">
                    <Link to={`/profile/${comment.author.id}`}>{comment.author.name}</Link>
                  </p>
                  <p className="text-sm text-gray-500">
                    {new Date(comment.createdAt).toLocaleDateString()}
                  </p>
                </div>
              </div>
              <div className="mt-2 text-sm text-gray-700">{comment.content}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostDetail; 